'use client';

import React from 'react';

import { useSupportStore } from '@/stores/support/useSupportStore';

import type { SupportSource } from '@/constants/dataLayer';
import type { SupportCategoryId } from '@/constants/support';

const SupportTrigger = ({
    children,
    className,
    source,
    categoryId
}: {
    children: React.ReactNode;
    className?: string;
    source: SupportSource;
    categoryId?: SupportCategoryId;
}) => {
    const openSupport = useSupportStore((store) => store.openSupport);

    return (
        <button type='button' onClick={() => openSupport(source, categoryId)} className={`all-unset cursor-pointer ${className ?? ''}`}>
            {children}
        </button>
    );
};

export default SupportTrigger;
